<div
  class="tile"
  #tileElement
  [style.background]="color"
  [class.with-content]="!!content"
>
  <div class="tile__header">
    <div class="tile__header__inner">
      <div class="tile__header__title">
        {{ title }}
      </div>
      <div class="tile__header__subtitle">
        <span [innerHTML]="subtitle"> </span>
      </div>
    </div>
    <div class="tile__header__icon-container" bpAddRtlClass>
      <bepatient-dynamic-icon [iconName]="icon" [color]="color" size="20px">
      </bepatient-dynamic-icon>
    </div>
  </div>
  <div class="tile__content" *ngIf="content">
    {{ content }}
  </div>
</div>
